import CustomButton from 'components/CustomInput/Button';
import CustomTable from 'components/CustomTable';
import moment from 'moment';
import React from 'react';
import { useHistory } from 'react-router';
import styled from 'styled-components/macro';

const SLayout = styled.div`
    padding: 15px;
`;

const SHeader = styled.div`
    font-weight: bold;
    font-size: 24px;
`;

const SCommentTableLayout = styled.div`
    margin-top: 20px;
`;

const SConfirmLayout = styled.div`
    margin-top: 30px;
    display: flex;
`;

const ReviewFeedback = (props) => {
    const history = useHistory();

    const columns = [
        { field: 'id', headerName: 'ID', width: 50 },
        { field: 'reviewer', headerName: 'Reviewer', width: 100 },
        { field: 'comment', headerName: 'Comment', width: 300 },
        { field: 'createdAt', headerName: 'Issue Date', width: 80 },
    ];

    const feedbacks = [
        {
            id: '1',
            reviewer: 'Mary',
            comment: 'This is review comment, This is review comment, This is review comment',
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            id: '2',
            reviewer: 'Peter',
            comment: 'This is review comment, This is review comment, This is review comment',
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            id: '3',
            reviewer: 'Paul',
            comment: 'This is review comment, This is review comment, This is review comment',
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
        {
            id: '4',
            reviewer: 'Mary',
            comment: 'This is review comment, This is review comment, This is review comment',
            createdAt: moment().format('YYYY-MM-DD HH:mm:ss'),
        },
    ];

    return (
        <SLayout>
            <SHeader>Review Feedbacks</SHeader>
            <SCommentTableLayout>
                <CustomTable columns={columns} rows={feedbacks} />
            </SCommentTableLayout>

            <SConfirmLayout>
                <CustomButton
                    showMargin
                    onClick={async () => {
                        history.push('/applications/confirm-review')
                    }}
                >
                    Make Final Decision
                </CustomButton>
                <CustomButton type={'cancel'} onClick={() => history.push('/applications/draft')} showMargin>
                    Cancel
                </CustomButton>
            </SConfirmLayout>
        </SLayout>
    );
};

export default ReviewFeedback;
